// Cobrança em lote (Dani, 19/09). O combinado de cada cliente mora numa linha das observações do cadastro — é a mesma
// linha que o robô lê (frequenciaDoCliente no robo.js): "COBRANÇA EM LOTE: SEMANAL — SEXTA" ou
// "COBRANÇA EM LOTE: QUINZENAL — DIAS 15 E 30". Sem a linha, a cobrança é diária (como sempre).
const DIAS_SEMANA = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];
const SEM_ACENTO = ["domingo", "segunda", "terca", "quarta", "quinta", "sexta", "sabado"];
const LINHA_LOTE = /cobran[çc]a em lote:\s*(semanal|quinzenal)([^\n]*)/i;

function lerFrequencia(obs) {
    const m = String(obs || "").match(LINHA_LOTE);
    if (!m) return { tipo: "diaria" };
    const resto = m[2].normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
    if (m[1].toLowerCase() === "semanal") {
        const dia = SEM_ACENTO.findIndex((d, i) => i > 0 && new RegExp(`\\b${d}`).test(resto));
        return { tipo: "semanal", dia: dia > 0 ? dia : 5 };
    }
    const dias = [...new Set((resto.match(/\d{1,2}/g) || []).map(Number).filter((n) => n >= 1 && n <= 31))].slice(0, 2);
    return { tipo: "quinzenal", dias: dias.length ? dias : [15, 30] };
}

function rotuloFrequencia(f) {
    if (!f || f.tipo === "diaria") return "Diária";
    if (f.tipo === "semanal") return `Semanal · toda ${DIAS_SEMANA[f.dia].toLowerCase()}`;
    return `Quinzenal · dias ${f.dias.join(" e ")}`;
}

// Tira a linha antiga (se tiver) e põe a nova no fim das observações; "diária" só tira.
function obsComFrequencia(obs, f) {
    const semLinha = String(obs || "")
        .split("\n")
        .filter((l) => !/cobran[çc]a em lote:/i.test(l))
        .join("\n")
        .trim();
    if (!f || f.tipo === "diaria") return semLinha;
    const linha =
        f.tipo === "semanal"
            ? `COBRANÇA EM LOTE: SEMANAL — ${DIAS_SEMANA[f.dia].toUpperCase()}`
            : `COBRANÇA EM LOTE: QUINZENAL — DIAS ${[...f.dias].sort((a, b) => a - b).join(" E ")}`;
    return semLinha ? `${semLinha}\n${linha}` : linha;
}

export { DIAS_SEMANA, lerFrequencia, rotuloFrequencia, obsComFrequencia };
